import { faqs, howItWorks, purchaseSeatsLanguages } from "./helpers";
import { routes } from "@/global/routes";
import { TopNavMenuItems } from "./helpers";
import { vendorUUIDs } from "../../constants";
import {
  DefaultRegistrationTerms,
  DefaultCheckoutTerms,
} from "../../default_terms_and_conditions";

import AuthBgBanner from "public/images/pistons/pistons.jpg";
import LogoImage from "public/images/pistons/detroit-pistons-logo.png";
import SeatMap3dPreview from "public/images/pistons/pistons_3d_venue.png";
import FindGamesBanner from "public/images/pistons/PushtothePlayoffs_Seasonshare.png";

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "pistons_accountrep",
  browserTitle: "Pistons 3 Game Push To The Playoffs",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "(248) 377-0100",
  manageCard: true,
  teamName: "Detroit Pistons",

  // standard one
  // dynamicPricing: {
  //   enabled: true,
  //   list: [
  //     {
  //       id: 1,
  //       minSelectedAmount: 0,
  //       updatedAccountGroup: 107,
  //       discount: 0,
  //     },
  //     {
  //       id: 2,
  //       minSelectedAmount: 10,
  //       updatedAccountGroup: 999,
  //       discount: 10,
  //       customAditionalMessage: " to receive additional savings?",
  //     },
  //   ],
  // },

  // temporary one
  dynamicPricing: {
    enabled: true,
    showAllDiscounts: true,
    list: [
      {
        id: 1,
        minSelectedAmount: 0,
        updatedAccountGroup: 998,
        discount: 5,
        customProgressBarMessage:
          "Congrats! You've unlocked 5% off your tickets. Add more games or checkout now.",
      },
    ],
  },

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-00064-pistons-sec",
    mapId: "main",
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seat configs
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: true,
    isCheckoutEditSeatsEnabled: true,
    isDiffSeatAlertEnabled: false,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: true,
    showFrontendServiceFee: true,
    hideViewTicketsInThankYouPage: true,

    isRepProduct: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: 3,
    allowedPaymentFailCount: 3,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "ec49f9fb-f0f2-4340-ae85-32fbeeab88d1",
    beaconId: "pistonssports",
    amazonPixelId: "9fdf4fbd-9154-4e73-9881-28fc480ea124",
    amazonTrackingEvent: "CHECKOUT_Detroit Pistons Basketball landing IHM 295",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/pistons/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  // images
  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: AuthBgBanner.src,
    checkoutStatusPageImage: AuthBgBanner.src,
    logoImage: LogoImage.src + "?width=76&height=76",
    logoNameImage: "",
    faviconImage:
      "https://ss-leagues.s3.amazonaws.com/NBA%2023-24%20Logos/Detroit%20Pistons%20.svg",
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: true,
      hideOverlayLogo: true,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    hideCheckoutCartBalance: false,

    checkoutStatusPage: {
      checkoutSuccessMessageFontWeight: "normal",
      checkoutSuccessMessageFontSize: "24px",
    },

    manageCard: {
      showPageTitle: false,
    },

    progressBar: {
      staticProgressBarText: true,
    },
  },

  colors: {
    primary: "#1d4699",
  },

  howItWorks,
  faqs,

  languages: {
    checkoutSuccessMessage:
      "Tickets will be delivered to your Detroit Pistons Account Manager.",
    topNavMenuItems: <TopNavMenuItems />,
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: purchaseSeatsLanguages,
    purchaseGiftCard: null,
    redeemGiftCard: null,
    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description:
              "If an intended recipient is not specified, once purchased, you will have to forward the unique code to the recipient. Upon your recipient receiving their gift card, they will be prompted to enter their unique code to redeem the gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
          sendNowTrue: {
            description:
              "The Recipient will be sent an email with the unique code for them to redeem their gift card. They can use the gift card for all events at the Hippodrome Broadway Series in Baltimore, Maryland.",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster account above.",
        },
        logout: {
          description:
            "Please input the case sensitive unique code provided to redeem the value of the gift card to the Ticketmaster.",
        },
        success: {
          description: "has been added to to your account!",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
